import { ItemIndicator } from "@radix-ui/react-dropdown-menu";

/**
 * DropdownItemIndicator
 * Container for the DropdownItems
 */

export default ItemIndicator;
